<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Meus Reembolsos</span>
      </v-row>

      <!-- LISTAGEM -->
      <v-row>
        <v-col cols="12" sm="12" md="9">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum reembolso cadastrado"
              hide-default-footer
              disable-sort
              :headers="cabecalho"
              :items="reembolsos"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
              loading-text="Carregando itens..."
            >
              <template v-slot:item.reembolso_nome="{ item }">
                <span>{{ item.reembolso_nome }}</span>
                <v-menu v-if="item.anexos.length" offset-x>
                  <template v-slot:activator="{ on }">
                    <v-btn small icon text v-on="on">
                      <v-icon small color="#ccc">mdi-rotate-45 mdi-paperclip</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="(a, index_a) in item.anexos" :key="index_a">
                      <a
                        @click="embed(a)"
                        target="_blank"
                        style="font-size:13px;"
                      >{{a.reembolso_anexo_nome}}</a>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:item.reembolso_valor="{ item }">
                <span>R$ {{ item.reembolso_valor }}</span>
              </template>
              <template v-slot:item.reembolso_status="{ item }">
                <v-chip small color="primary" v-if="item.reembolso_status == 1">Aberto</v-chip>
                <v-chip
                  small
                  color="#5cbbf6"
                  text-color="white"
                  v-if="item.reembolso_status == 2"
                >Em Análise</v-chip>
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="red"
                      text-color="white"
                      v-if="item.reembolso_status == 3"
                    >Reprovado</v-chip>
                  </template>
                  <span v-if="item.reembolso_motivo">{{item.reembolso_motivo}}</span>
                </v-tooltip>
                <v-chip
                  small
                  color="green"
                  text-color="white"
                  v-if="item.reembolso_status == 4"
                >Aprovado</v-chip>
              </template>
              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>
                <v-menu offset-x v-if="editModulo">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                  >Mostrar menos</v-btn>
                  <v-btn
                    v-if="formData.length > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                  >Carregar mais</v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda">
              <v-col class="mr-8">
                <v-btn
                  @click="novoReembolso()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480  !important;"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1">mdi-cash-usd-outline</v-icon>
                  <span class="white--text">Novo reembolso</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIALOG CADASTRAR/EDITAR -->
    <v-dialog v-model="dialog_reembolso" persistent width="900px">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            {{ formData.id_reembolso ? 'Editar reembolso' : 'Novo reembolso'}}
            <v-spacer></v-spacer>
            <v-chip
              small
              color="#283480"
              class="white--text"
              v-if="formData.reembolso_status == 1"
            >Aberto</v-chip>
            <v-chip
              small
              color="#5cbbf6"
              text-color="white"
              v-if="formData.reembolso_status == 2"
            >Em Análise</v-chip>
            <v-tooltip top color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="red"
                  text-color="white"
                  v-if="formData.reembolso_status == 3"
                >Reprovado</v-chip>
              </template>
              <span v-if="formData.reembolso_motivo">{{formData.reembolso_motivo}}</span>
            </v-tooltip>
            <v-chip
              small
              color="green"
              text-color="white"
              v-if="formData.reembolso_status == 4"
            >Aprovado</v-chip>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Nome *</span>
                <v-text-field
                  required
                  :rules="requiredRules"
                  v-model="formData.reembolso_nome"
                  solo
                  dense
                  flat
                  outlined
                  :autofocus="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Valor *</span>
                <money
                  class="input"
                  v-model.lazy="formData.reembolso_valor"
                  v-bind="moneyFormat"
                  required
                  :rules="requiredRules"
                ></money>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="mb-n5">
                <span class="font-weight-bold black--text">Descrição *</span>
                <v-textarea
                  required
                  :rules="requiredRules"
                  v-model="formData.reembolso_descricao"
                  solo
                  dense
                  flat
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="mb-n5">
                <span class="font-weight-bold black--text">Anexos</span>
                <!-- CADASTRAR -->
                <v-file-input
                  show-size
                  prepend-icon="mdi-rotate-45 mdi-paperclip"
                  solo
                  v-model="formData.anexos"
                  outlined
                  flat
                  dense
                  multiple
                  v-if="!formData.id_reembolso"
                ></v-file-input>
                <!-- EDITAR -->
                <v-file-input
                  show-size
                  prepend-icon="mdi-rotate-45 mdi-paperclip"
                  solo
                  v-model="formData.anexosNew"
                  outlined
                  flat
                  dense
                  multiple
                  v-if="formData.id_reembolso"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row
              v-if="formData.id_reembolso && formData.anexos.length"
              class="d-inline-flex align-items-center"
            >
              <v-col cols="12" sm="12" md="12" class="mb-n5 d-inline-flex align-items-center">
                <span
                  v-for="(a, index) in formData.anexos"
                  :key="index"
                  class="mr-4 d-inline-flex align-items-center"
                >
                  <a @click="embed(a)" target="_blank">{{a.reembolso_anexo_nome}}</a>
                  <v-icon
                    small
                    class="ml-1"
                    @click="dialog_delete_anexo = true, itemAnexo = a"
                  >mdi-delete-outline</v-icon>
                </span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                :loading="loadingSalvar"
                :disabled="loadingSalvar"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG DELETAR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este reembolso?</v-card-title>
        <v-card-text>Se deletar este reembolso ele não poderá ser recuperado!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="close()">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :loading="loadingSalvar"
            :disabled="loadingSalvar"
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG EXCLUIR ANEXO -->
    <v-dialog v-model="dialog_delete_anexo" persistent max-width="650">
      <v-card class="borda" flat>
        <v-card-title class="headline">Deseja realmente excluir este anexo?</v-card-title>
        <v-card-text>Esta ação é irreversível!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="closeExcluirAnexo()">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :loading="loadingExcluirAnexo"
            :disabled="loadingExcluirAnexo"
            @click="deleteAnexo()"
          >Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_historico" persistent width="750">
      <v-card class="borda" flat>
        <v-card-title>
          <span class="headline ma-3">Histórico de alteração</span>
          <v-spacer></v-spacer>
          <v-btn icon text @click="dialog_historico = false">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <v-card outlined class="borda" :loading="loadingHistorico">
            <v-simple-table fixed-header max-height="500px" v-if="historico.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Motivo</th>
                    <th class="text-center">Status</th>
                    <th class="text-left">Quem</th>
                    <th class="text-right">Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in historico" :key="index">
                    <td>
                      <v-chip
                        small
                        v-bind:class="{'orange lighten-3': item.reembolso_historico_motivo == 1}"
                      >{{ item.reembolso_historico_motivo == 1 ? 'Alterado': "Inalterado" }}</v-chip>
                    </td>

                    <td>
                      <v-row justify="center">
                        <v-chip
                          v-bind:class="{'primary':item.reembolso_historico_status == 1,
                        'blue lighten-3':item.reembolso_historico_status == 2,
                        'red':item.reembolso_historico_status == 3,
                        'green':item.reembolso_historico_status == 4}"
                          small
                          class="text-uppercase white--text"
                          v-text="alterado(item.reembolso_historico_status)"
                        ></v-chip>
                      </v-row>
                    </td>
                    <td>
                      <v-avatar size="32" v-if="imgAWS(item.usuario)">
                        <img :src="getHash(item.usuario)" :lazy-src="getHash(item.usuario)" />
                      </v-avatar>
                      <v-avatar size="32" color="#283480" v-else-if="!item.usuario.usuario_imagem">
                        <span
                          class="white--text headline text-uppercase"
                        >{{item.usuario.usuario_nome.charAt(0)}}</span>
                      </v-avatar>
                      <v-avatar size="32" v-else-if="item.usuario">
                        <img
                          :src="item.usuario.usuario_imagem"
                          :lazy-src="item.usuario.usuario_imagem"
                        />
                      </v-avatar>
                      <span class="ml-1">{{ item.usuario.usuario_nome }}</span>
                    </td>
                    <td class="text-right">{{ item.created_at | moment('L [às] LT') }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row v-else class="ma-1" justify="center">Nenhuma alteração realizada</v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";

export default {
  data: () => {
    return {
      loadingHistorico: false,
      dialog_historico: false,
      historico: [],
      loading: false,
      loadingSalvar: false,
      loadingExcluirAnexo: false,
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" },
        { nome: "⠀Histórico", icon: "mdi-history" }
      ],
      menu1: false,
      menu2: false,
      dialog_reembolso: false,
      dialog_delete: false,
      dialog_delete_anexo: false,
      reembolsos: [],
      formData: {
        id_reembolso: "",
        reembolso_nome: "",
        reembolso_descricao: "",
        reembolso_valor: "",
        reembolso_status: "",
        reembolso_motivo: "",
        anexos: []
      },
      status: [
        { value: 1, text: "Aberto" },
        { value: 2, text: "Em Análise" },
        { value: 3, text: "Reprovado" },
        { value: 4, text: "Aprovado" }
      ],
      valid: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      cabecalho: [
        { text: "Nome", align: "start", value: "reembolso_nome" },
        { text: "Valor", align: "start", value: "reembolso_valor" },
        { text: "Status", align: "start", value: "reembolso_status" },
        { text: "Ações", align: "end", sortable: false, value: "acao" }
      ],
      editModulo: true,
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      itemAnexo: ""
    };
  },
  computed: {},
  created() {
    this.getReembolsos();
    this.validaEdicaoModulo();
  },
  methods: {
    alterado(item) {
      return this.status[item - 1].text;
    },
    getHistorico(item) {
      this.historico = [];
      this.loadingHistorico = true;
      Api.get(`/meu_titulo/historico/` + item.id_reembolso)
        .then(response => {
          if (response) {
            this.historico = response.data.data;
            this.loadingHistorico = false;
          }
        })
        .catch(err => {
          this.loadingHistorico = false;
          throw err;
        });
    },
    getHash(item) {
      let url =
        Api.getApUrl() +
        "/usuarios/imagem/show?img=" +
        item.usuario_imagem_hash;
      return url;
    },
    imgAWS(item) {
      if (item.usuario_imagem) {
        if (item.usuario_imagem.indexOf("amazonaws.com/") != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    menu(opcao, item) {
      this.formData.id_reembolso = item.id_reembolso;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Histórico") {
        this.getHistorico(item);
        this.dialog_historico = true;
      } else if (opcao.nome === "⠀Editar") {
        this.formData = {
          id_reembolso: item.id_reembolso,
          reembolso_nome: item.reembolso_nome,
          reembolso_descricao: item.reembolso_descricao,
          reembolso_valor: item.reembolso_valor,
          reembolso_status: item.reembolso_status,
          reembolso_motivo: item.reembolso_motivo,
          anexos: item.anexos
        };
        this.dialog_reembolso = true;
      }
    },

    deleteItem() {
      this.loadingSalvar = true;
      Api.delete(`/meu_titulo/deleteR/` + this.formData.id_reembolso)
        .then(response => {
          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            this.formData.id_reembolso = "";
            this.getReembolsos();
            this.loadingSalvar = false;
          } else {
            this.$toast.warning(response.data.errors);
            this.formData.id_reembolso = "";
            this.loadingSalvar = false;
          }
        })
        .catch(err => {
          this.loadingSalvar = false;
          throw err;
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loadingSalvar = true;

        if (this.formData.reembolso_valor > 0) {
          var endpoint = "";
          var msg = "";
          if (!this.formData.id_reembolso) {
            // CADASTRAR
            endpoint = "/meu_titulo/new";
            msg = "Castradado com sucesso!";
          } else {
            // EDITAR
            this.formData.reembolso_status = 1;
            endpoint = "/meu_titulo/edit/" + this.formData.id_reembolso;
            msg = "Editado com sucesso!";
          }

          let formData = new FormData();
          Object.keys(this.formData).map(key => {
            if (key === "anexos") {
              for (let i = 0; i < this.formData.anexos.length; i++) {
                let file = this.formData.anexos[i];
                if (this.formData.anexos[i].name) {
                  formData.append(`anexos[]`, file);
                }
              }
            } else if (key === "anexosNew") {
              for (let i = 0; i < this.formData.anexosNew.length; i++) {
                let file = this.formData.anexosNew[i];
                formData.append(`anexos[]`, file);
              }
            } else {
              if (this.formData[key]) {
                formData.append(key, this.formData[key]);
              }
            }
          });
          Api.post(endpoint, formData)
            .then(response => {
              if (response) {
                this.loadingSalvar = false;
              }
              this.loadingSalvar = false;
              this.$toast.success(msg);
              this.getReembolsos();
              this.$refs.form.resetValidation();
              this.close();
            })
            .catch(err => {
              this.loadingSalvar = false;
              this.$toast.error("Oops! Ocorreu um erro.");
              throw err;
            });
        } else {
          this.loadingSalvar = false;
          this.$toast.error("Valor deve ser maior que 0!");
        }
      }
    },

    getReembolsos() {
      this.loading = true;
      Api.get(`/meu_titulo/reembolsos-usuario`)
        .then(response => {
          if (response.data.data) {
            this.reembolsos = response.data.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },

    carregarMais() {
      if (this.reembolsos.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },

    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.dialog_reembolso = false;
      this.dialog_delete = false;
      this.formData = {
        id_reembolso: "",
        reembolso_nome: "",
        reembolso_descricao: "",
        reembolso_valor: "",
        reembolso_status: "",
        anexos: []
      };
    },

    novoReembolso() {
      this.dialog_reembolso = true;
    },

    deleteAnexo() {
      this.loadingExcluirAnexo = true;
      Api.delete(`/meu_titulo/anexo/` + this.itemAnexo.id_reembolso_anexo)
        .then(response => {
          let anexo = this.itemAnexo.id_reembolso_anexo;
          if (response) {
            this.loadingExcluirAnexo = false;
          }
          this.formData.anexos = this.formData.anexos.filter(function(item) {
            return item.id_reembolso_anexo != anexo;
          });
          this.$toast.success("Excluído com sucesso!");
          this.closeExcluirAnexo();
          this.getReembolsos();
        })
        .catch(err => {
          this.loadingExcluirAnexo = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },

    closeExcluirAnexo() {
      this.dialog_delete_anexo = false;
      this.loadingExcluirAnexo = false;
      this.itemAnexo = "";
    },

    embed(item) {
      const url =
        Api.getApUrl() + `/anexo-reembolso/show?id=` + item.id_reembolso_anexo;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", item.reembolso_anexo_nome);
      document.body.appendChild(link);
      link.click();
    },

    async validaEdicaoModulo() {
      // this.editModulo = await Api.validaEdicaoModulo(
      //   this.$router.currentRoute.path
      // );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>